import React, { useState } from "react";
import S from "./Avatar.styled";
const initials = (text) => {
    var _a;
    const regex = /\p{L}{1}\p{L}+/gu;
    const matches = text.match(regex) || [];
    const first = (value) => { var _a; return ((_a = value === null || value === void 0 ? void 0 : value[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || ""; };
    return `${first((_a = matches === null || matches === void 0 ? void 0 : matches[0]) !== null && _a !== void 0 ? _a : "")}${first(matches[matches.length - 1])}`;
};
const colors = [
    "#BFB2F3",
    "#96CAF7",
    "#9CDCAA",
    "#E5E1AB",
    "#F3C6A5",
    "#F8A3A8",
];
const pickColor = (text) => {
    const index = (text.charCodeAt(0) || 0) % colors.length;
    return colors[index];
};
const Avatar = ({ src = "", alt = "" }) => {
    const [internalSrc, setInternalSrc] = useState(src);
    return internalSrc ? (React.createElement(S.Image, { src: src, alt: alt, onError: () => setInternalSrc("") })) : (React.createElement(S.Initials, { "data-testid": "initials", color: pickColor(alt) }, initials(alt)));
};
export default Avatar;
//# sourceMappingURL=Avatar.js.map